<template>
  <span class="notranslate" translate="no"><slot /></span>
</template>
